import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';
import _partition from 'lodash/partition';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import { get as gc } from '../../../../utils/GlobalCssProxy';

// TODO: move this logic to get-asset-class
const shortTermOtherRegex = /^short-term, other/i;

const AssetAllocation = ({ allocations, asOfDate, ticker }) => {
  // Short term investments should always be at the last index if it exists
  const formatAllocations = orderedAllocations => {
    const lastIndex = orderedAllocations.length - 1;
    const shortTermAllocationIndex = orderedAllocations.findIndex(
      allocation =>
        allocation.assetType === 'Short-Term Investments, Other Assets & Liabilities, Net'
    );

    if (shortTermAllocationIndex !== -1 && shortTermAllocationIndex !== lastIndex) {
      orderedAllocations.splice(
        lastIndex,
        0,
        orderedAllocations.splice(shortTermAllocationIndex, 1)[0]
      );
    }
    return orderedAllocations;
  };

  // sort items by allocation
  let itemsOrdered =
    allocations && allocations.length
      ? formatAllocations(_orderBy(allocations.filter(Boolean), ['allocationPercent'], ['desc']))
      : [{ assetType: '--', allocationPercent: 0 }];

  // move short-term, other assets and liabilities to end
  const [shortTermOther, rest] = _partition(
    itemsOrdered,
    i => i && shortTermOtherRegex.test(i.assetType)
  );
  itemsOrdered = [...rest, ...shortTermOther];

  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_AssetAllocation"
      data-analytics-section="component"
      className={gc('printing-padding-top')}
    >
      <CardModule.Header>
        Asset Allocation
        <CardModule.AsOfDateMedBlock>{format.date(asOfDate)}</CardModule.AsOfDateMedBlock>
      </CardModule.Header>
      <CardModule.Body>
        <TableBasic flush>
          <caption className={gc('sr-only')}>Asset allocation for {ticker}</caption>
          <thead>
            <tr>
              <th className={gc('text-left')}>
                <div className={gc('sr-only')}>Asset Type</div>
              </th>
              <th className={gc('text-right')}>% of Net Assets</th>
            </tr>
          </thead>
          <tbody>
            {itemsOrdered.map((item, index) => {
              return (
                <tr
                  data-key={`${item.assetType || ''}-${index}`}
                  key={`${item.assetType || ''}-${index}`}
                >
                  <th scope="row" className={gc('text-left')}>
                    {format.text(item.assetType)}
                  </th>
                  <td className={gc('text-right', 'font-weight-bold')}>
                    {item.allocationPercent ? format.percent(item.allocationPercent) : '--'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </TableBasic>
      </CardModule.Body>
      <CardModule.Footer className={gc('text-right')}>
        <ButtonDisclosures module={'asset-allocation'} />
      </CardModule.Footer>
    </CardModule>
  );
};

AssetAllocation.propTypes = {
  asOfDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      assetType: PropTypes.string,
      allocationPercent: PropTypes.number
    })
  ),
  ticker: PropTypes.string
};

AssetAllocation.defaultProps = {
  allocations: [],
  ticker: null
};

export default AssetAllocation;
